<template>
  <el-pagination
    layout="prev, pager, next"
    :total="items"
    :page-size="pageSize"
    @current-change="handlePageChange"
    :pager-count="5"
  />
</template>

<script lang="ts" setup>
import { computed } from "vue";

const props = defineProps<{
  totalItems: number;
  pageSize?: number;
}>();

const emits = defineEmits(["update:page"]);

const items = computed(() => props.totalItems || 0);
const pageSize = computed(() => props.pageSize || 100);

const handlePageChange = (page: number) => {
  console.log("page", page);
  emits("update:page", page);
};
</script>

<style lang="scss">
@use "element-plus/theme-chalk/el-pagination.css";
@use "element-plus/theme-chalk/el-button.css";
@use "element-plus/theme-chalk/el-icon.css";
</style>
